import CustomFieldComponent from './CustomFieldComponent'

export default CustomFieldComponent
